export const baseURL = process.env.REACT_APP_API_HOST;
export const gRecaptchaClientKey = String(
  process.env.REACT_APP_G_RECAPTCHA_CLIENT_KEY,
);
